// v2 vuelve a mostrar una sola vez la nueva entrevista de creación incluso a quienes
// ya habían completado el recorrido básico anterior.
export const BLACKED_ONBOARDING_KEY = "blackred-studio.blacked-onboarding.v2";
export const BLACKED_START_EVENT = "blackred:start-blacked";

export function startBlackedOnboarding() {
  window.dispatchEvent(new Event(BLACKED_START_EVENT));
}
